/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {TemplatePortal} from '../core/portal/portal';
import {
  ViewContainerRef, Input, TemplateRef, ViewChild, OnInit, ContentChild,
  Component
} from '@angular/core';
import {CanDisable, mixinDisabled} from '../core/common-behaviors/disabled';
import {MdTabLabel} from './tab-label';
export class MdTabBase {}
export const /** @type {?} */ _MdTabMixinBase = mixinDisabled(MdTabBase);
export class MdTab extends _MdTabMixinBase implements OnInit, CanDisable {
/**
 * Content for the tab label given by <ng-template md-tab-label>.
 */
templateLabel: MdTabLabel;
/**
 * Template inside the MdTab view that contains an <ng-content>.
 */
_content: TemplateRef<any>;
/**
 * The plain text label for the tab, used when there is no template label.
 */
textLabel: string = '';
/**
 * The portal that will be the hosted content of the tab
 */
private _contentPortal: TemplatePortal = null;
/**
 * @return {?}
 */
get content(): TemplatePortal { return this._contentPortal; }
/**
 * The relatively indexed position where 0 represents the center, negative is left, and positive
 * represents the right.
 */
position: number = null;
/**
 * The initial relatively index origin of the tab if it was created and selected after there
 * was already a selected tab. Provides context of what position the tab should originate from.
 */
origin: number = null;
/**
 * @param {?} _viewContainerRef
 */
constructor(private _viewContainerRef: ViewContainerRef) {
    super();
  }
/**
 * @return {?}
 */
ngOnInit() {
    this._contentPortal = new TemplatePortal(this._content, this._viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-tab, mat-tab',
  templateUrl: 'tab.html',
  inputs: ['disabled']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateLabel': [{ type: ContentChild, args: [MdTabLabel, ] },],
'_content': [{ type: ViewChild, args: [TemplateRef, ] },],
'textLabel': [{ type: Input, args: ['label', ] },],
};
}

function MdTab_tsickle_Closure_declarations() {
/** @type {?} */
MdTab.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdTab.ctorParameters;
/** @type {?} */
MdTab.propDecorators;
/**
 * Content for the tab label given by <ng-template md-tab-label>.
 * @type {?}
 */
MdTab.prototype.templateLabel;
/**
 * Template inside the MdTab view that contains an <ng-content>.
 * @type {?}
 */
MdTab.prototype._content;
/**
 * The plain text label for the tab, used when there is no template label.
 * @type {?}
 */
MdTab.prototype.textLabel;
/**
 * The portal that will be the hosted content of the tab
 * @type {?}
 */
MdTab.prototype._contentPortal;
/**
 * The relatively indexed position where 0 represents the center, negative is left, and positive
 * represents the right.
 * @type {?}
 */
MdTab.prototype.position;
/**
 * The initial relatively index origin of the tab if it was created and selected after there
 * was already a selected tab. Provides context of what position the tab should originate from.
 * @type {?}
 */
MdTab.prototype.origin;
/** @type {?} */
MdTab.prototype._viewContainerRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
